import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useStore } from "@/stores";
import { Message } from "element-ui";
import { Request } from "@/utils/Request";
import { API_BIS_DATA_DOWNLOAD, API_BIS_ASSET } from "@/configs/Apis";
// @ts-expect-error aaaa
import VueOfficePdf from "@vue-office/pdf/lib/v2/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentPdfViewer',
  props: {
  patentId: { type: [String, Number], required: true },
  // 父组件控制：切到 PDF tab 时才传 true
  active: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;



const store = useStore();
const projectId = computed(() => (store.state as any).project.info?.id ?? 0);

const http = new Request();

// ---------- 状态 ----------
const pdfLoading = ref(false);
const pdfRendering = ref(false);
const pdfPreviewUrl = ref("");
const loaded = ref(false);

// ---------- 调 download-assets，确保 PDF 已下载到本地 ----------
const fetchAssets = async () => {
  if (!props.patentId || !projectId.value || loaded.value) return;
  pdfLoading.value = true;
  try {
    const url = API_BIS_DATA_DOWNLOAD.replace("{projectId}", String(projectId.value));
    const res: any = await http.request(url, { patentId: props.patentId }, "POST");

    const data = res?.data ?? res ?? {};
    const pdfPath = data.pdf;
    if (pdfPath) {
      const cleanPath = String(pdfPath).trim().replace(/^\/+/, "");
      const assetUrl = API_BIS_ASSET.replace("{projectId}", String(projectId.value));
      pdfPreviewUrl.value = `/api${assetUrl}?patentId=${props.patentId}&path=${encodeURIComponent(cleanPath)}`;
      pdfRendering.value = true;
    }
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      Message.warning("部分附件下载失败");
    }
    loaded.value = true;
  } catch (e: any) {
    console.error("[PatentPdfViewer] PDF 下载失败:", e);
    Message.error("PDF 加载失败");
  } finally {
    pdfLoading.value = false;
  }
};

// 切到 tab 时触发
watch(
  () => props.active,
  (isActive) => {
    if (isActive) fetchAssets();
  },
  { immediate: true }
);

// 换专利时重置并重新下载
watch(
  () => props.patentId,
  () => {
    loaded.value = false;
    pdfPreviewUrl.value = "";
    pdfRendering.value = false;
    if (props.active) fetchAssets();
  }
);

function onPdfRendered() {
  pdfRendering.value = false;
}

function onPdfError() {
  pdfRendering.value = false;
  Message.error("PDF 渲染失败");
}

return { __sfc: true,props, store, projectId, http, pdfLoading, pdfRendering, pdfPreviewUrl, loaded, fetchAssets, onPdfRendered, onPdfError, VueOfficePdf }
}

})